/**
 * list类型货架通用mixins
 * 主要是 懒加载路基
 */

import { mapGetters } from "vuex"
import * as helper from "@utils/helper"

export default {
  data() {
    return {
      propsList: [],
      totalGoods: [],
      numInPage: helper.getNumInPage() || 8,
      placeholderGoods: ["", "", "", ""],
      isLoading: false,
      noGoodsTips: "道具更新中",
      throttledFunction: null
    }
  },

  computed: {
    ...mapGetters(["currentItemKey"])
  },

  methods: {
    initScroll() {
      if (this.throttledFunction) return
      this.onScroll = this.onScroll.bind(this)
      this.throttledFunction = helper.throttle(this.onScroll, 500)
      window.addEventListener("scroll", this.throttledFunction)
    },
    destroyScroll() {
      window.removeEventListener("scroll", this.throttledFunction)
      this.throttledFunction = null
    },
    onScroll() {
      let currentNumInPage = Math.ceil(helper.getScrollTop() / 200) * 2 + this.numInPage
      if (this.propsList.length < currentNumInPage) {
        this.propsList = this.totalGoods.slice(0, currentNumInPage)
      }
    }
  }
}
